import { FC, useMemo, useRef, useState } from 'react';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import IconFont from '@/common/components/IconFont';
import TaskHistory from './TaskHistory';
import TaskChangeModal from '@/common/components/business/ExpandStore/TaskDetailCommon/TaskChangeModal';
import { TaskChange, TaskStatus, TaskStatusTagStyle, EmergencyDegree } from '@/common/components/business/ExpandStore/ts-config';
import { isArray, isNotEmptyAny, refactorPermissions } from '@lhb/func';
import styles from '../index.module.less';
// import cs from 'classnames';
import { useBigdataFn } from '@/common/utils/bigdata';
import { useMethods } from '@lhb/hook';
import V2Operate from '@/common/components/Others/V2Operate';
import V2Title from '@/common/components/Feedback/V2Title';
import SimpleEdit from 'src/views/expandstore/pages/expansioncirclesenmatask/components/Edit/SimpleEdit';

/**
 * 拓店任务：森马（参考clusterA直营）-详情-顶部信息
 * @Description
 */
const Header: FC<{
  detail: any;
  isApproval?: boolean;
  isHistory?: boolean;
  hideOperate?: boolean;
  onRefresh?: () => void;
}> = ({
  detail,
  isApproval = false,
  isHistory = false,
  hideOperate = false,
  onRefresh
}) => {

  /* state */
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [historyVisible, setHistoryVisible] = useState<boolean>(false); // 任务历史弹框
  const [changeVisible, setChangeVisible] = useState<boolean>(false); // 异动申请弹框
  const simpleEditRef = useRef<any>(null);

  /**
   * 是否展示紧急度图标
   * @description 「踩点紧急度：一周内完成 」和「备选点上传紧急度：两周内完成 」 有一个就展示
   */
  const showEmergencyDegreeIcon = detail?.spotSurveyEmergencyDegree === EmergencyDegree.Very || detail?.chancePointEmergencyDegree === EmergencyDegree.Very;

  /** 操作按钮 */
  const operateList = useMemo(() => {
    return [
      /** 是否展示任务历史按钮：历史详情页、或已变更不展示任务历史 */
      {
        name: '历史拓店任务', event: 'history', type: 'default',
        // parentId 有值说明有历史拓店
        visible: !isApproval && !isHistory && isNotEmptyAny(detail) && detail.status !== TaskStatus.Changed && !!detail.parentId
      },
      /** 是否展示开发异动按钮，有启用异动、未提交异动、且有异动权限时展示 */
      {
        name: '开发异动', event: 'taskChange', type: 'default',
        visible: !hideOperate && isNotEmptyAny(detail) && detail.taskChangeApprovalStatus === TaskChange.None && isArray(detail.buttons) && !!detail.buttons.length && detail.taskChangeButton === 1,
      },
      /** 是否展示开发异动审批中按钮，异动审批中时展示 */
      {
        name: '开发异动中', event: 'taskApproving', type: 'default',
        visible: !isApproval && detail && detail.taskChangeApprovalStatus === TaskChange.Approving
      },
      {
        name: '编辑', event: 'edit', type: 'primary',
        visible: !isApproval && isArray(detail?.permissions) && !!detail.permissions.some((perm: any) => perm.event === 'standardTask:edit'),
      },
    ].filter(item => item.visible);
  }, [detail]);

  /* hooks */

  /* methods */
  const methods = useMethods({

    /**
     * @description 任务历史
     */
    handleHistory: () => {
      // 历史弹框
      setHistoryVisible(true);
      bigdataFn('ed8b2cfd-a8b7-43d2-9ca1-1fa42f22bf2d', '拓店任务详情-历史任务', '点击了拓店任务详情-历史任务', { op_block: '拓店任务管理', op_event: ``, });
    },

    /**
     * @description 点击开发异动
     */
    handleTaskChange: () => {
      // 申请异动弹框
      setChangeVisible(true);
      bigdataFn('a96efd64-8c31-496e-85c5-073a84aae7a2', '拓店任务详情-开发异动', '点击了拓店任务详情-开发异动', { op_block: '拓店任务管理', op_event: ``, });
    },

    /**
     * @description 点击开发异动中
     */
    handleTaskApproving: () => {
      V2Message.warning(`异动申请中，在我发起的审批中查看`);
    },

    /** 编辑 */
    handleEdit: () => {
      simpleEditRef.current?.init(detail.id);
    },

  });

  return (<div className={styles.taskDetailHeader} >
    <V2Title
      extra={
        <V2Operate
          showBtnCount={4}
          operateList={refactorPermissions(operateList)}
          onClick={(btns: { func: string | number }) => methods[btns.func]()}
        />
      }>
      <div className={styles.titleWrapper}>
        <span className={'fs-20 bold c-222'}>
          {showEmergencyDegreeIcon && <IconFont iconHref='iconic_jinjidu' className='mr-5 fs-20'></IconFont>}
          {detail?.name}
        </span>
        <div
          className={styles.statusBox}
          style={{
            ...TaskStatusTagStyle[detail?.status]
          }}
        >{detail?.statusName}</div>
      </div>
    </V2Title>

    {/* 任务历史 */}
    <TaskHistory
      open={historyVisible}
      setOpen={setHistoryVisible}
      id={detail.id}
      expansionTaskAlias='拓店任务'
    />

    {/* 开发异动 */}
    <TaskChangeModal
      visible={changeVisible}
      setVisible={setChangeVisible}
      detail={detail}
      onRefresh={onRefresh}
    />

    {/* 编辑拓店任务 */}
    <SimpleEdit ref={simpleEditRef} onRefresh={onRefresh} />

  </div>);
};
export default Header;
